<template>
  <el-select
    v-model="value"
    clearable
    filterable
    size="large"
    placeholder="Select level"
    class="w-100"
  >
    <el-option
      v-for="item in getData"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "level-dropdown",
  data() {
    return {
      value: ""
    };
  },
  methods: {
    ...mapActions("LevelsModule", ["fetchData"])
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters("LevelsModule", ["getData"]),
  }
});
</script>
